import React from 'react';
import { motion } from 'framer-motion';
export function SocialProof() {
  const customEase = [0.16, 1, 0.3, 1];
  const testimonials = [{
    quote: 'The masterclass completely changed how I approach my everyday makeup. So much practical advice I could actually use the next morning.',
    name: 'Sarah M.',
    city: 'Brisbane',
    initials: 'SM'
  }, {
    quote: 'An incredibly premium experience from start to finish. I left feeling genuinely confident for the first time.',
    name: 'Jessica L.',
    city: 'Sydney',
    initials: 'JL'
  }, {
    quote: "The best investment I've made in myself this year. The hands-on guidance was exactly what I needed.",
    name: 'Emma K.',
    city: 'Melbourne',
    initials: 'EK'
  }, {
    quote: 'I booked a private class for my birthday and it was absolutely flawless. My friends are still talking about it.',
    name: 'Chloe T.',
    city: 'Brisbane',
    initials: 'CT'
  }];
  // Duplicate for seamless marquee
  const marqueeItems = [...testimonials, ...testimonials];
  return <section className="py-24 md:py-32 bg-white overflow-hidden" data-id="element-330">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12 mb-16 text-center" data-id="element-331">
        <h2 className="font-serif text-4xl md:text-5xl font-light text-ink mb-4" data-id="element-332">
          Words from our <span className="italic" data-id="element-333">Students</span>
        </h2>
      </div>

      <div className="relative flex overflow-hidden py-4 group" data-id="element-334">
        <div className="flex gap-8 px-4 w-max animate-marquee group-hover:[animation-play-state:paused]" data-id="element-335">
          {/* Double the items for seamless loop */}
          {[...testimonials, ...testimonials].map((testimonial, index) => <div key={index} className="relative w-[350px] md:w-[450px] flex-shrink-0 bg-white p-8 md:p-10 border border-cream-dark shadow-sm overflow-hidden" data-id="element-336">
              <svg className="absolute top-4 left-4 w-10 h-10 text-cream-dark opacity-40 z-0" fill="currentColor" viewBox="0 0 24 24" data-id="element-337">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-338" />
              </svg>
              <p className="font-serif text-2xl md:text-3xl font-light italic text-ink leading-relaxed mb-8 relative z-10 pt-6" data-id="element-339">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-340">
                <div className="w-10 h-10 rounded-full bg-copper/10 flex items-center justify-center flex-shrink-0" data-id="element-341">
                  <span className="font-sans text-xs font-medium text-copper tracking-widest" data-id="element-342">
                    {testimonial.initials}
                  </span>
                </div>
                <div data-id="element-343">
                  <p className="font-sans text-sm font-medium text-ink uppercase tracking-widest mb-1" data-id="element-344">
                    {testimonial.name}
                  </p>
                  <p className="font-sans text-xs text-stone uppercase tracking-widest" data-id="element-345">
                    {testimonial.city}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}